'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { HighLightHorizontal } from '@/assets/icons';
import { backgrounds, dividers } from '@/assets/materials';
import HexagonalButton from '@/components/bases/HexagonalButton';

export const HeroSection = () => {
  const router = useRouter();

  const openAdminPage = () => {
    window.open(process.env.NEXT_PUBLIC_ADMIN_URL, '_blank');
  };

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      minHeight={'100dvh'}
      flexGrow={1}
      justifyContent={'center'}
      paddingX={{ xs: '24px', md: '80px' }}
      paddingY={{ xs: '190px', md: '176px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}
      sx={{
        backgroundImage: `url(${backgrounds.hero_bg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <Stack width={'min(1280px, 100%)'} zIndex={2}>
        <Stack gap={{ xs: 5, md: 7 }} width={'100%'} maxWidth={'807px'}>
          <Stack width={'100%'} alignItems={'center'} direction={'row'} gap={1}>
            <HighLightHorizontal width={'65px'} height={'10px'} />
            <Stack className={'w-full'} justifyContent={'center'}>
              <Image
                src={dividers.divider_2}
                alt={'divider'}
                width={400}
                height={2}
                style={{ width: '100%', height: 'auto' }}
              />
            </Stack>
          </Stack>
          <Stack gap={3} width={'100%'} paddingRight={'47px'}>
            <Typography
              component={'h1'}
              variant={'displayLarge'}
              className={'clip-text'}
              fontSize={{ xs: '32px', md: '56px' }}
              lineHeight={{ xs: '40px', md: '68px' }}
              sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
              THE FUTURE OF CORE SALES IS HERE
            </Typography>
            <Typography
              fontSize={{ xs: '14px', md: '18px' }}
              component={'h4'}
              variant={'bodyLarge'}
              color={'#FFFFFF'}
              className={'mix-blend'}>
              A permissionless platform built for founders, investors, and communities to fund and fuel the future of
              Web3.
            </Typography>
          </Stack>
          <Stack alignItems={'center'} gap={2} direction={{ xs: 'column', md: 'row' }} maxWidth={'560px'}>
            <Stack
              width={'100%'}
              alignItems={{ xs: 'flex-start', md: 'center' }}
              gap={2}
              direction={{ xs: 'column', md: 'row' }}>
              <Stack width={'100%'} display={{ xs: 'none', md: 'block' }}>
                <HexagonalButton
                  variant={'primary'}
                  label={'EXPLORE CORE SALES'}
                  onClick={() => router.push('/explore')}
                />
              </Stack>
              <Stack width={202} display={{ xs: 'block', md: 'none' }}>
                <HexagonalButton
                  variant={'primary'}
                  label={'EXPLORE CORE SALES'}
                  size={'small'}
                  onClick={() => router.push('/explore')}
                />
              </Stack>
              <Stack width={'100%'} display={{ xs: 'none', md: 'block' }}>
                <HexagonalButton variant={'secondary'} label={'START YOUR LAUNCH'} onClick={openAdminPage} />
              </Stack>
              <Stack width={202} display={{ xs: 'block', md: 'none' }}>
                <HexagonalButton
                  variant={'secondary'}
                  label={'START YOUR LAUNCH'}
                  size={'small'}
                  onClick={openAdminPage}
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack alignItems={'center'} direction={'row'} gap={1}>
            <Stack className={'w-full'} justifyContent={'center'}>
              <Image
                src={dividers.divider_2}
                alt={'divider'}
                width={400}
                height={2}
                style={{ width: '100%', height: 'auto', transform: 'rotate(180deg)' }}
              />
            </Stack>
            <HighLightHorizontal width={'65px'} height={'10px'} color={'#FF5319'} />
          </Stack>
          <Stack>
            <Link href={'https://hashlock.com/audits/lfg'} target='_blank'>
              <Image src={'/icons/hashlock.png'} alt='Hashlock' width={142} height={42} />
            </Link>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        zIndex={1}
        position={'absolute'}
        top={0}
        left={0}
        right={0}
        bottom={0}
        sx={{
          background:
            'linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), linear-gradient(180deg, rgba(6, 9, 18, 0) 50%, #060912 100%)',
        }}
      />
    </Stack>
  );
};
